import $ from 'jquery';
import 'slick-carousel';
import breakpoints from '../data/breakpoints';
import { get } from 'lodash';


class Carousel {
    constructor(el, options = {}) {
        this.el = $(el);
        this.slidesEl = el.find('.carousel__slides');
        this.prevArrow = el.find('.carousel__controls__prev');
        this.nextArrow = el.find('.carousel__controls__next');
        this.pausePlayButton = el.find('.carousel__controls__pause-play');
        this.data = el.data();
        this.loading = true;
        this.autoplay = get(this.data, ['autoplay'], 'false').toLowerCase() == 'true';
        this.autoplaySpeed = this.data.autoplaySpeed || 4000;
        this.options = Object.assign({}, {
            // normal options...
            infinite: true,
            slidesToShow: 1,
            dots: false,
            arrows: false,
            adaptiveHeight: true,
            pauseOnHover: false,
            pauseOnFocus: false,
            fade: true,
            autoplay: this.autoplay,
            autoplaySpeed: this.autoplaySpeed,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: breakpoints.desktop - 1,
                    settings: {
                        fade: false
                    }
                }
            ]
        }, options);


        this.slick = this.slidesEl.slick(this.options);
        this._configureCarouselControls();

    }

    _configurePlayPauseButton() {

        if (!this.pausePlayButton) {
            return;
        }
        if (this.autoplay)
        {
            this._setPlayPauseButtonIcon(!this.autoplay);
        }
        this.pausePlayButton.click(() => {

            if (this.autoplay) {
                this.autoplay = false;
                this.slick.slick('slickPause');
            }
            else {
                this.autoplay = true;
                this.slick.slick('slickPlay');
            }
            this._setPlayPauseButtonIcon(!this.autoplay);
        });

    }
    _setPlayPauseButtonIcon(displayPlay) {
        if (!this.pausePlayButton)
        {
            return;
        }
        if (displayPlay) {
            this.pausePlayButton
                .removeClass('carousel__controls__icons--pause')
                .addClass('carousel__controls__icons--play');
        }
        else {
            this.pausePlayButton
                .removeClass('carousel__controls__icons--play')
                .addClass('carousel__controls__icons--pause');
        }
    }
    _configureCarouselControls() {
        this.prevArrow.click(() => {
            this.slick.slick('slickPrev');
        });
        this.nextArrow.click(() => {
            this.slick.slick('slickNext');
        });
        this._configurePlayPauseButton();
    }


}

export default Carousel;